export const LangEnum = {
  En: "en-US",
}
